import {
    FETCH_DISABLED_RULES,
    FETCH_DISABLED_RULES_FAIL,
    FETCH_DISABLED_RULES_SUCCESS,
    FETCH_ENABLED_RULES,
    FETCH_ENABLED_RULES_FAIL,
    FETCH_ENABLED_RULES_SUCCESS,
    FETCH_RULES,
    FETCH_RULES_FAIL,
    FETCH_RULES_SUCCESS,
    UPDATE_RULE,
    UPDATE_RULE_FAIL,
    UPDATE_RULE_STATUS,
    UPDATE_RULE_STATUS_FAIL,
    UPDATE_RULE_STATUS_SUCCESS,
    UPDATE_RULE_SUCCESS
} from './actionTypes';

export const fetchRules = args => ({
    type: FETCH_RULES,
    payload: args
});
export const fetchRulesSuccess = () => ({
    type: FETCH_RULES_SUCCESS
});
export const fetchRulesFail = args => ({
    type: FETCH_RULES_FAIL,
    payload: args
});
export const fetchEnabledRules = args => ({
    type: FETCH_ENABLED_RULES,
    payload: args
});
export const fetchEnabledRulesSuccess = args => ({
    type: FETCH_ENABLED_RULES_SUCCESS,
    payload: args
});
export const fetchEnabledRulesFail = args => ({
    type: FETCH_ENABLED_RULES_FAIL,
    payload: args
});

export const fetchDisabledRules = args => ({
    type: FETCH_DISABLED_RULES,
    payload: args
});
export const fetchDisabledRulesSuccess = args => ({
    type: FETCH_DISABLED_RULES_SUCCESS,
    payload: args
});

export const fetchDisabledRulesFail = args => ({
    type: FETCH_DISABLED_RULES_FAIL,
    payload: args
});

export const updateRule = args => ({
    type: UPDATE_RULE,
    payload: args
});
export const updateRuleSuccess = response => ({
    type: UPDATE_RULE_SUCCESS,
    payload: response
});
export const updateRuleFail = error => ({
    type: UPDATE_RULE_FAIL,
    payload: error
});

export const updateRuleStatus = args => ({
    type: UPDATE_RULE_STATUS,
    payload: args
});
export const updateRuleStatusSuccess = response => ({
    type: UPDATE_RULE_STATUS_SUCCESS,
    payload: response
});
export const updateRuleStatusFail = error => ({
    type: UPDATE_RULE_STATUS_FAIL,
    payload: error
});
